import pageSection from './pageSection'

export default pageSection
